export default "__VITE_ASSET__ccQLdLxs77C6vK88rAaGsw__"